import { render, staticRenderFns } from "./DateSelector.vue?vue&type=template&id=652495b9&scoped=true&"
import script from "./DateSelector.vue?vue&type=script&lang=js&"
export * from "./DateSelector.vue?vue&type=script&lang=js&"
import style0 from "./DateSelector.vue?vue&type=style&index=0&id=652495b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652495b9",
  null
  
)

export default component.exports